var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58214 0 0 3.58214 0 8C0 12.4179 3.58214 16 8 16C12.4179 16 16 12.4179 16 8C16 3.58214 12.4179 0 8 0ZM8 14.6429C4.33214 14.6429 1.35714 11.6679 1.35714 8C1.35714 4.33214 4.33214 1.35714 8 1.35714C11.6679 1.35714 14.6429 4.33214 14.6429 8C14.6429 11.6679 11.6679 14.6429 8 14.6429Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14307 4.85714C7.14307 5.08447 7.23337 5.30249 7.39412 5.46323C7.55486 5.62398 7.77288 5.71429 8.00021 5.71429C8.22754 5.71429 8.44555 5.62398 8.6063 5.46323C8.76705 5.30249 8.85735 5.08447 8.85735 4.85714C8.85735 4.62981 8.76705 4.4118 8.6063 4.25105C8.44555 4.09031 8.22754 4 8.00021 4C7.77288 4 7.55486 4.09031 7.39412 4.25105C7.23337 4.4118 7.14307 4.62981 7.14307 4.85714ZM8.42878 6.85714H7.57164C7.49307 6.85714 7.42878 6.92143 7.42878 7V11.8571C7.42878 11.9357 7.49307 12 7.57164 12H8.42878C8.50735 12 8.57164 11.9357 8.57164 11.8571V7C8.57164 6.92143 8.50735 6.85714 8.42878 6.85714Z",
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_1076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleIcon);
export default __webpack_public_path__ + "static/media/info-circle-icon.3cef8f692bf8498ac6d6555832df502f.svg";
export { ForwardRef as ReactComponent };